<template>
  <v-hover>
    <template #default="{ hover }">
      <TContextInformation>
        <template #default>
          <TWorkPackage
            class="test-border"
            :key="`workpackage${workpackage.id}`"
            :workpackage_count="waggon[tworkpackages_string].length"
            :workpackage="workpackage"
            :easter_egg="easter_egg"
            :color="workpackage_color"
            :textcolor="workpackage_text_color"
            >
            <template #workpackage="workpackageslot">
              <StandardHover
                v-if="isTworkPackageHover(
                  workpackage.id,
                  workpackageslot.workpackage,
                  hover,
                  new_milestone.milestone)"
                :class="hover && $route.matched[3] && $route.matched[3].name === 'TaktPlanWorkPackageInfo'?'cursor-grab':'cursor-pointer'"
                :key="`workpackagehover${workpackage.id}`"
                :border_style="snackbar[snackbar.selector.select_key + '_id'] == workpackage.id && snackbar.show ? 'dashed' : ''"
                @click.native="handleTWorkpackageClick(
                  train,
                  waggon,
                  workpackageslot.workpackage,
                  train.id,
                  taktarea.id,
                  waggon.id,
                  workpackage.id,
                  $event
                  )"
                />
                <!-- <StandardHover
                v-else-if="
                  snackbar && snackbar.show && snackbar.selector &&
                  snackbar[this.snackbar.selector.select_key + '_type'] == 'tworkpackages' &&
                  snackbar[this.snackbar.selector.select_key + '_id'] == workpackage.id"
                :class="hover && $route.matched[3] && $route.matched[3].name === 'TaktPlanWorkPackageInfo'?'cursor-grab':'cursor-pointer'"
                border_style="dashed"
                @click.native="handleTWorkpackageClick(
                  train,
                  waggon,
                  workpackageslot.workpackage,
                  train.id,
                  taktarea.id,
                  waggon.id,
                  workpackage.id,
                  $event
                  )"
                /> -->
              <transition
                name="zoom"
                >
                <StandardBadge
                  class="cursor-pointer"
                  v-if="!(hover_waggon && isEditMode) && !$store.state.View.isTokenView &&
                        workpackageslot.workpackage.status &&
                        (workpackageslot.workpackage.status !== 'none' || workpackageslot.workpackage.stop_status !== 'none') &&
                        isShowStatusBadges &&
                        workpackage.status !== 'stop'
                        "
                  :key="`workpackagebadge${workpackage.id}`"
                  :icon="workpackage.stop_status !== 'none'?(workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === workpackageslot.workpackage.status).icon"
                  color="white"
                  :content_color="workpackageslot.workpackage.stop_status !== 'none' ? 'red':'black'"
                  @click.native="$route.name === 'ProjectTaktPlan'?$emit('openWaggonInfo', $event):''"
                />
              </transition>
              <StandardBadgeMini
                v-if="workpackageslot.workpackage.status &&
                      workpackageslot.workpackage.status !== 'none' &&
                      !isShowStatusBadges"
                />
            </template>
          </TWorkPackage>
        </template>
        <template #information>
          <WorkpackageInformation :workpackage="workpackage" prefix="t" histprefix="" />
        </template>
      </TContextInformation>
    </template>
  </v-hover>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';

  import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
  import WorkpackageInformation from '@/components/ProjectTaktPlan/WorkpackageInformation.component.vue';
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
  import StandardBadgeMini from '@/components/StandardComponents/StandardBadgeMini.component.vue'
  import StandardHover from '@/components/StandardComponents/StandardHover.component.vue'
  import TContextInformation from '@/components/Taktify/TContextInformation.component.vue';

  export default {
    props: [
      'project_id',
      'workpackage',
      'train',
      'taktarea',
      'waggon',
      'easter_egg',
      'new_milestone',
      'location',
      'milestone_selection',
      'snackbar',
      'hover_waggon',
    ],
    components: {
      TWorkPackage,
      StandardBadge,
      StandardBadgeMini,
      StandardHover,
      TContextInformation,
      WorkpackageInformation,
    },
    data: () => ({
    }),
    // updated() {
    //   console.log('tpworkpackage wrapper updated');
    // },
    computed: {
      tworkpackages_string(){
        if (this.location === 'HistProject') {
          return 'histtworkpackages';
        } else {
          return 'tworkpackages';
        }
      },
      workpackage_color() {
        //flexbar filter
        if (this.getStatisticSettings.filter) {
          if (
            this.wpIsGrey('colors', this.workpackage.color) ||
            this.wpIsGrey('icons', this.workpackage.icon) ||
            this.wpIsGrey('status', this.workpackage.status, this.workpackage.stop_status) ||
            // this.wpIsGrey('status', this.workpackage.stop_status) ||
            this.wpIsGrey('trains', this.train.id) ||
            //stopstatus
            (this.getStatisticSettings.status.length === 1 && this.getStatisticSettings.status.includes('stop') && this.workpackage.stop_status !== 'stop') ||
            (this.getStatisticSettings.status.length !== 0 && !this.getStatisticSettings.status.includes('stop') && this.workpackage.stop_status === 'stop')
          ) {
            return 'grey darken-3';
          }
        }
        //show own wps
        if (
          this.isShowOwnWps
          && this.getOwnTWorkPackages(this.project_id).length !== 0
          && !this.getOwnTWorkPackages(this.project_id).includes(this.workpackage.id)
        ) {
          return 'grey darken-3';
        }
        // take workpackage color
        return false;
      },
      workpackage_text_color() {
        //flexbar filter
        if (this.getStatisticSettings.filter) {
          if (
            this.wpIsGrey('colors', this.workpackage.color) ||
            this.wpIsGrey('icons', this.workpackage.icon) ||
            this.wpIsGrey('status', this.workpackage.status, this.workpackage.stop_status) ||
            // this.wpIsGrey('status', this.workpackage.stop_status) ||
            this.wpIsGrey('trains', this.train.id) ||
            //stopstatus
            (this.getStatisticSettings.status.length === 1 && this.getStatisticSettings.status.includes('stop') && this.workpackage.stop_status !== 'stop') ||
            (this.getStatisticSettings.status.length !== 0 && !this.getStatisticSettings.status.includes('stop') && this.workpackage.stop_status === 'stop')
          ) {
            return 'grey darken-4';
          }
        }
        //show own wps
        if (
          this.isShowOwnWps
          && this.getOwnTWorkPackages(this.project_id).length !== 0
          && !this.getOwnTWorkPackages(this.project_id).includes(this.workpackage.id)
        ) {
          return 'grey darken-4';
        }
        // take workpackage color
        return 'black';
      },
      ...mapGetters('ProjectStatistics', [
        'getStatisticSettings',
      ]),
      ...mapGetters('View', [
          'isShowOwnWps',
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
        'getStatusArray',
        'isEditMode',
        'isShowStatusBadges',
      ]),
      ...mapGetters('ProjectMilestone', [
        'getNewMilestone',
        'getMileStoneLinkType',
      ]),
      ...mapGetters('SnackBar', [
        'getAffectedTargets',
        'getAffectedIdsSelector'
      ]),
    },
    methods: {
      ...mapActions('ProjectMilestone', [
        'updateMilestoneBulk',
        'updateNewMilestoneBulk',
        'resetNewMilestone',
        'editMilestoneSelection',
        'editNewMilestoneSelection',
      ]),
      wpIsGrey(settings_key, value, stop_status) {
        if (
          this.getStatisticSettings[settings_key].length !== 0 &&
          !this.getStatisticSettings[settings_key].includes(value)
          //prevent stop status
          && !(this.getStatisticSettings.status.includes('stop') && stop_status === 'stop')
        ) {
          return true;
        } else {
          // if (settings_key === 'status') {

          //   console.log('not grey');
          // }
          return false;
        }
      },
      ...mapActions('SnackBar', [
        'editAffectedTargets',
        'editParentTargets',
        'editSelector'
      ]),
      handleTWorkpackageClick(train, waggon, work_package, train_id, taktarea_id, waggon_id, workpackage_id, evt) {
        if(this.snackbar && this.snackbar.show && this.snackbar.selector) {
          if (this.snackbar[this.snackbar.selector.select_key + '_type'] == "tworkpackages"&& this.snackbar[this.snackbar.selector.select_key + '_id'] != this.workpackage.id) {
          this.editSelector(this.workpackage.id);
          }
          else {
            this.$emit('openWaggonInfo', evt);
          }
        }
        // if (this.snackbar && this.snackbar.show && this.snackbar.target_type === 'tworkpackages') {
        //   this.editAffectedTargets({workpackage_id, waggon_id, taktarea_id, train_id});
        // } else if (this.snackbar && this.snackbar.show && this.snackbar.target_type.substring(this.snackbar.target_type.length -5) === 'steps') {
        //   this.editParentTargets(workpackage_id);
        // }
        else {
          if (this.$route.name === 'TrainMilestonesAdd' &&
            this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
            this.editNewMilestoneSelection({
              project_id: this.project_id,
              prop: 'tworkpackages',
              value: work_package,
              train: train,
            });
          }
          else if (this.$route.name === 'TrainMilestonesAdd' &&
            this.getNewMilestone(this.project_id).milestone.linkType === 'type') {
            this.updateNewMilestoneBulk([
              {prop: 'wp_color_active', value: true},
              {prop: 'wp_color', value: work_package.color},
              {prop: 'wp_token_active', value: true},
              {prop: 'wp_token', value: work_package.token},
              {prop: 'wp_icon_active', value: true},
              {prop: 'wp_icon', value: work_package.icon},
              {prop: 'wp_name_active', value: true},
              {prop: 'wp_name', value: work_package.name},
            ]);
          }
          else if (this.$route.name === 'TrainMilestonesEdit' &&
              this.getMileStoneLinkType({
                project_id: this.project_id,
                milestone_id: this.$route.params.milestone_id
              }) === 'selection') {
            this.editMilestoneSelection({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id,
              prop: 'tworkpackages',
              value: work_package,
              train: train,
            });
          }
          else if (this.$route.name === 'TrainMilestonesEdit' &&
              this.getMileStoneLinkType({
                project_id: this.project_id,
                milestone_id: this.$route.params.milestone_id
              }) === 'type') {
            this.updateMilestoneBulk({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id,
              type: 'milestones',
              data: [
                {prop: 'wp_color_active', value: true},
                {prop: 'wp_color', value: work_package.color},
                {prop: 'wp_token_active', value: true},
                {prop: 'wp_token', value: work_package.token},
                {prop: 'wp_icon_active', value: true},
                {prop: 'wp_icon', value: work_package.icon},
                {prop: 'wp_name_active', value: true},
                {prop: 'wp_name', value: work_package.name},
              ]
            });
          }
          else {
            this.$emit('openWaggonInfo', evt)
            // this.openWaggonInfo(
            //   waggon,
            //   train_id,
            //   taktarea_id,
            //   waggon_id,
            //   evt,
            //   workpackage_id,
            // );
          }
        }
      },
      isTworkPackageHover(workpackage_id, workpackage, hover, new_milestone) {
        // If mouse is over Workpackage and Any workpackage is open
        if (this.snackbar && this.snackbar.show && this.snackbar.selector){
          if (this.snackbar[this.snackbar.selector.select_key + '_type'] != 'tworkpackages'){
            return false
          }
          if (this.snackbar[this.snackbar.selector.select_key + '_type'] == 'tworkpackages' && hover){
            return true
          }
        }
        if (hover && this.$route.name !== 'ProjectTaktPlan') {
          return true;
        }

        // else if (this.$route.params.tworkpackage_id === workpackage_id && !this.snackbar.hover && this.$route.matched[4] && this.$route.matched[4].name.substring(0,19) === 'TaktPlanWorkPackage') {
        //   console.log('2');
        //   return true;
        // }
        
        // else if ( !this.snackbar.hover && parseInt(this.$route.params.tworkpackage_id) === parseInt(workpackage_id) ) {
        //   return true;
        // }

        // new milestone with linkType = select
        if (new_milestone.tworkpackages.indexOf(workpackage_id) !== -1 &&
            this.$route.name === 'TrainMilestonesAdd' && new_milestone.linkType === 'selection'
          ) {
          return true;
        }

        // new milestone with linType = type
        if (new_milestone.linkType === 'type' &&
          ((new_milestone.wp_color_active && new_milestone.wp_color === workpackage.color) || !new_milestone.wp_color_active) &&
          ((new_milestone.wp_token_active && new_milestone.wp_token === workpackage.token) || !new_milestone.wp_token_active) &&
          ((new_milestone.wp_icon_active && new_milestone.wp_icon === workpackage.icon) || !new_milestone.wp_icon_active) &&
          ((new_milestone.wp_name_active && new_milestone.wp_name === workpackage.name) || !new_milestone.wp_name_active) &&
          !(!new_milestone.wp_color_active && !new_milestone.wp_token_active && !new_milestone.wp_icon_active && !new_milestone.wp_name_active) &&
          this.$route.name === 'TrainMilestonesAdd'
        ) {
          return true;
        }

        // workpackge part of selected milestone
        if (this.milestone_selection.tworkpackages.includes(workpackage_id) &&
          ['TrainMilestonesDetails', 'TrainMilestonesEdit'].includes(this.$route.name)
        ) {
          return true;
        }

        // active snackbar
        if (this.snackbar && this.snackbar.show) {
          
          if (this.snackbar.selector && 
            this.snackbar[this.snackbar.selector.select_key + '_type'] == 'tworkpackages'
            ) {
            // WP is selected
            if ((this.getAffectedIdsSelector.includes(workpackage_id) || this.snackbar[this.snackbar.selector.select_key + '_id'] == workpackage_id)) {
              return true;
            }
          }
          if (this.snackbar.hover && this.snackbar.action !== 'updateparent' && this.snackbar.target_type === 'tworkpackages' && (this.getAffectedTargets.includes(workpackage_id) || this.snackbar.target_id === workpackage_id)) {
            return true;
          }
          
          else if (this.snackbar.target_type.substring(this.snackbar.target_type.length-5) === 'steps' && this.snackbar.affected_parents.includes(workpackage_id)) {
            return true;
          }
        }

        // no active snackbar and workpackage is open : check after checking snackbar
        if ( workpackage.is_open ) {
          return true;
        }
        return false;
        
      }
    }
  }
</script>
<style>
  .class {

  }
</style>
